import "Styles/templates/page.amb-details.scss";

import ProductSlider from '../vue/product-slider/index';

ProductSlider();